const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="user-avatar-icon">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
)

function Avatar({ photoURL, displayName }) {
  return (
    <>
      {photoURL ? (
        <img src={photoURL} alt="Avatar" className="user-avatar" />
      ) : (
        <UserIcon />
      )}
      <span className="user-name">{displayName || 'User'}</span>
    </>
  )
}

export default Avatar
